export default "__VITE_ASSET__w7ABT_YY__"